import { TypedEventEmitter } from '../shared/typed-event-emitter';

/**
 * Backward-compatible EventDispatcher that wraps TypedEventEmitter.
 */
export class EventDispatcher extends TypedEventEmitter<Record<string, unknown>> {
  addEventListener(type: string, listener: (event: unknown) => void): void {
    this.subscribe(type, listener);
  }

  hasEventListener(type: string, listener: (event: unknown) => void): boolean {
    return this.hasListener(type, listener);
  }

  removeEventListener(type: string, listener: (event: unknown) => void): void {
    this.unsubscribe(type, listener);
  }

  removeEventListeners(type: string): void {
    this.removeAllListeners(type);
  }

  dispatchEvent(event: { type: string; [key: string]: unknown }): void {
    event.target = this;
    this.emit(event.type, event);
  }
}
